import { StageDEndorseFormInfo } from '../../../models/classes/stage-d/Review-Application.class';

/**
 * Filters an array of StageDEndorseFormInfo objects based on specific conditions.
 * @param {StageDEndorseFormInfo[] | undefined} endorseForms - Array of StageDEndorseFormInfo objects
 * @param {string} loginUserUinfin - Current logged in user's UINFIN
 * @param {string} spouse - User's spouse UINFIN (default: "")
 * @returns {StageDEndorseFormInfo[]} - Filtered array based on specified conditions
 */
export const currentOwnerIncludedEndorseManuallySentDraft = (
  endorseForms: StageDEndorseFormInfo[] | undefined,
  loginUserUinfin: string,
  spouse: string = ''
) => {
  if (endorseForms === undefined) {
    return [];
  } else {
    //   return endorseForms.filter(form =>
    //   (form.biome_status.toLowerCase() === "manually_sent"
    //     && form.signify_status.toLowerCase() === "draft"
    //     && form.owners.some(owner => owner.uinfin === loginUserUinfin)
    //     && form.owners.some(owner => owner.endorsement_date === undefined)
    //   ));

    return endorseForms.filter(
      (form) =>
        form.biome_status.toLowerCase() === 'manually_sent' &&
        form.signify_status.toLowerCase() === 'draft' &&
        form.owners.some((owner) => owner.uinfin === loginUserUinfin) &&
        (form.occupiers.some((occform) => occform.uinfin === spouse && occform.endorsement_date === undefined) ||
          form.owners.some((owner) => owner.endorsement_date === undefined) ||
          (spouse !== '' && form.occupiers.some((occuper) => occuper.uinfin === spouse))) &&
        form.signing_require
    );
  }
};
